/**
 * OpentokRecording Device implementation.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


/**
 * @implements {IDevice}
 */
export default class Device {
    /**
     * Instantiates a Device.
     *
     * @param {string} id Device id
     * @param {string} name Device name
     * @param {string} type Device type
     */
    constructor(id, name, type) {
        this.id = id;
        this.name = name;
        this.type = type;
    }

    /**
     * @return {string}
     */
    getId() {
        return this.id;
    }

    /**
     * @return {string}
     */
    getName() {
        return this.name;
    }

    /**
     * @return {string}
     */
    getType() {
        return this.type;
    }
}
